module.exports = __webpack_public_path__ + "static/media/myImage.13539553.jpg";